import { forwardRef } from 'react'

import styles from './WhiteInput.module.scss'

const WhiteInput = forwardRef(
  ({ isHandWritten, width, type = 'text', disabled = false, ...props }, ref) => (
    <input
      {...props}
      className={[styles.input, isHandWritten ? styles.handWrittenInput : ''].join(' ')}
      type={type}
      disabled={disabled}
      autoComplete="off"
      style={{ width }}
      ref={ref}
    />
  )
)

export default WhiteInput
